import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';

import shapeImg1 from '../../assets/img/hero/shape-3-1.png';
import shapeImg2 from '../../assets/img/hero/shape-3-2.png';
import shapeImg3 from '../../assets/img/hero/shape-1-3.png';
import heroImg from '../../assets/img/hero/hero-3-1.jpg';
import heroIcon from '../../assets/img/hero/icon-1.png';

const Hero = () => {
  return (
    <div className="it-hero-3-area fix p-relative z-index grey-bg-2">
      <div className="it-hero-3-shape-1">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xxl-8 col-xl-7 col-lg-7">
            <div className="it-hero-content">
              <span
                className="it-section-subtitle tertiary mb-15 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
              >
                حلول العناية بالعيون من الخبراء
              </span>
              <h1
                className="it-hero-title pb-5 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".5s"
              >
                العناية بالعيون والصحة الشاملة <span>مركز</span>
              </h1>
              <div
                className="it-hero-text mb-30 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".7s"
              >
                <p>
                  من المهم أن يكون لديك خدمة عملاء، ولكن ستتبعها خدمة عملاء في
                  مثل هذا الوقت تحدث كما هو الحال مع المخاض والألم <br /> كبير
                  بعض لكي نصل إلى أصغر التفاصيل، ما هو تمريننا؟
                </p>
              </div>
              <div
                className="it-hero-button-wrapper wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".8s"
              >
                <Link to="/about-us" className="it-btn-theme tertiary-bg">
                  <Button btnText="اكتشف المزيد" />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xxl-4 col-xl-5 col-lg-5">
            <div className="it-hero-3-right p-relative text-center text-lg-end">
              <div className="it-hero-3-shape-2 d-none d-md-block">
                <img src={shapeImg2} alt="" />
              </div>
              <div className="it-hero-shape-3 d-none d-xl-block">
                <img src={shapeImg3} alt="" />
              </div>
              <div className="it-hero-3-thumb">
                <img src={heroImg} alt="" />
              </div>
              <div className="it-hero-doctor-wrap">
                <div className="it-hero-doctor-box d-flex align-items-center justify-content-start">
                  <div className="it-hero-doctor-icon">
                    <span>
                      <img src={heroIcon} alt="" />
                    </span>
                  </div>
                  <div className="it-hero-doctor-text text-end">
                    <span>200+</span>
                    <p>
                      أفضل الأطباء في العالم
                      <br />
                      التشاور
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
